jQuery(function($){

$(document).ready(function () {

	$('.filter_radio label').click(function(){
		if(!$(this).closest('.filter_radio').hasClass('filter_open')) $(this).closest('.filter_radio').addClass('filter_open');
		else {
			if($('#'+$(this).attr('for')).hasClass('all_options')) {
				$(this).closest('.filter_radio').addClass('filter_reset');
				$(this).closest('.filter_radio').find('.filter_arrow').removeClass('filter_choosen');
			} else {
				$(this).closest('.filter_radio').removeClass('filter_reset');
				$(this).closest('.filter_radio').find('.filter_arrow').addClass('filter_choosen');
			}
			$(this).closest('.filter_radio').removeClass('filter_open');
		}
	});

	$('.filter_arrow').click(function(){
		$(this).closest('.filter_radio').toggleClass('filter_open');
	});

	var department = '';
	var area = '';
	$('.careers-filter input').change(function(){
		if($(this).attr('name') == 'department') department = $(this).val();
		if($(this).attr('name') == 'area') area = $(this).val();

		if(!department && !area) {$('.careers-list li').show();}
		if(!department && area) {
			$('.careers-list li').each(function(){
				if($(this).text().indexOf(area) != -1) $(this).show();
				else $(this).hide();
			});
		}
		if(department && !area) {
			$('.careers-list li').each(function(){
				if($(this).text().indexOf(department) != -1) $(this).show();
				else $(this).hide();
			});
		}
		if(department && area) {
			$('.careers-list li').each(function(){
				if($(this).text().indexOf(department) != -1 && $(this).text().indexOf(area) != -1) $(this).show();
				else $(this).hide();
			});
		}

	});

});


});